import ConfigService from '../services/config.service';
import featureFlagService, { PROJECT_MOVE_ENABLED_FLAG } from '../services/feature-flag.service.js';
import { BaseService } from './base.service';

class MenuItem {
  constructor(name, icon, route, displayOrderInGroup, enabled, openInNewWindow=false) {
    this.name=name;
    this.icon=icon;
    this.route = route;
    this.enabled=enabled;
    this.displayOrderInGroup=displayOrderInGroup;
    this.openInNewWindow = !!openInNewWindow;
  }
}

export class MenuService extends BaseService {
  constructor() {
    super()
    ConfigService.registerCallback(this.makeMenuItemsFromConfig, "menuServiceCallback");
    this.menuItemsMap = new Map();
  }

  makeMenuItemsFromConfig = async (config) => {
    this.menuItemsMap.set("main", [
      new MenuItem("Portfolio", "images/icons/skills.svg", "/skills", 1, config.SKILLS_ENABLED),
      new MenuItem("Facewall", "images/icons/names-and-faces.svg", "/facewall", 3, true),
      new MenuItem("Swag store", "images/icons/cart.svg", "/store", 4, config.STORE_ENABLED),
      new MenuItem("Surveys", "images/icons/survey-question.svg", "/surveys", 5, config.SURVEYS_ENABLED),
      new MenuItem("Events", "images/icons/white-calendar.svg", "/events", 6, config.EVENTS_ENABLED),
      new MenuItem("Project Move","images/icons/suitcase-white.svg","/project-move-dashboard", 2, await featureFlagService.getBooleanFeatureFlag(PROJECT_MOVE_ENABLED_FLAG, false)),
      new MenuItem("Context Layer", "images/icons/components.svg", "/context-layer", 7, config.CONTEXT_LAYER_ENABLED),
    ]);
    this.menuItemsMap.set("dev", [
      new MenuItem("Components", "images/icons/components.svg", "/components",  1, config.APP_COMPONENTS_ENABLED),
      new MenuItem("Report a bug", "images/icons/bug.svg", "https://bbdgitlab.bbd.co.za/the-hive/the-hive/-/issues", 2, true, true),
    ]);
    this.menuItemsMap.set("learning", [
      new MenuItem("Courses", "images/icons/courses.svg", "/tracks", 1, true),
      new MenuItem("Side quests", "images/icons/side-quest-new.svg", "/side-quests", 2, true),
      new MenuItem("Level-ups", "images/icons/level-up-new.svg", "/level-ups", 3, true),
      new MenuItem("Programmes", "images/icons/courses.svg", "/programmes", 4, config.PROGRAMMES_ENABLED),
      new MenuItem("Leaderboard", "images/icons/level-up.svg", "/leaderboard", 5, config.LEADERBOARD_ENABLED),
    ]);
    this.menuItemsMap.set("quest", [
      new MenuItem("Quest Log", "images/icons/quest-log.svg", "/log", 1, true),
      new MenuItem("Quest History", "images/icons/quest-history.svg", "/quest-history", 2, true),
    ]);
  }

  activeMenuItems(group){
    return this.menuItemsMap.get(group)?.filter(menuItem => menuItem.enabled)??[];
  }
}

export default new MenuService();
